// import React from "react";
// import styled from "styled-components";

// // Styled Components for the Modal
// const ModalBackground = styled.div`
//   position: fixed;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   background-color: rgba(0, 0, 0, 0.7);
//   display: ${(props) => (props.isOpen ? "flex" : "none")};
//   justify-content: center;
//   align-items: center;
//   z-index: 1000;
// `;

// const ModalContainer = styled.div`
//   background: linear-gradient(145deg, #0d0d0d, #1a1a1a);
//   font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
//   border: 1px solid #1f1f21;
//   padding: 2rem;
//   border-radius: 10px;
//   width: 80%;
//   max-width: 600px;
//   box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
//   font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
// `;

// const ModalHeader = styled.h2`
//   margin-bottom: 1rem;
//   color: #e6e6e6;
// `;

// const ModalContent = styled.p`
//   color: #e6e6e6;
//   line-height: 1.6;
//   font-size: 1rem;
//   font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
//   strong {
//     color: #3f51ff;
//   }
// `;

// const CloseButton = styled.button`
//   background: #194bfd;
//   background: linear-gradient(
//     90deg,
//     rgba(25, 75, 253, 1) 0%,
//     rgba(173, 19, 251, 1) 100%
//   );
//   transition: all 0.3s ease;
//   color: #dee2e6;
//   border: none;
//   padding: 0.5rem 1rem;
//   margin-top: 1.5rem;
//   cursor: pointer;
//   font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;

//   transition: all 0.3s ease;
//   &:hover {
//     background-color: #5a189a;

//     color: #ffffff;
//     transform: translateY(-2px);
//     box-shadow: 0 6px 16px rgba(90, 24, 154, 0.5);
//   }
// `;

// const Modal = ({ isOpen, onClose }) => {
//   return (
//     <ModalBackground isOpen={isOpen}>
//       <ModalContainer>
//         <ModalHeader>Welcome to Passport Assistance Services</ModalHeader>
//         <ModalContent>
//           Hello, thank you for visiting our Passport Assistance Services
//           website. Please note that we are not a government entity. We provide
//           assistance in applying for passports, including fresh passport
//           applications, re-issues, and document inquiries. As a trusted passport
//           agent, we make the process seamless for you.
//           <br />
//           <br />
//           <strong>
//             For any assistance, please get in touch with us via our contact form
//             or call us directly.
//           </strong>
//         </ModalContent>
//         <CloseButton onClick={onClose}>Close</CloseButton>
//       </ModalContainer>
//     </ModalBackground>
//   );
// };

// export default Modal;

import React from "react";
import styled from "styled-components";

// Styled Components for the Modal
const ModalBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: ${(props) => (props.$isOpen ? "flex" : "none")};
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContainer = styled.div`
  background: linear-gradient(145deg, #0d0d0d, #1a1a1a);
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  border: 1px solid #1f1f21;
  padding: 2rem;
  border-radius: 10px;
  width: 80%;
  max-width: 600px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
`;

const ModalHeader = styled.h2`
  margin-bottom: 1rem;
  color: #e6e6e6;
`;

const ModalContent = styled.p`
  color: #e6e6e6;
  line-height: 1.6;
  font-size: 1rem;

  strong {
    color: #3f51ff;
  }
`;

const CloseButton = styled.button`
  background: linear-gradient(90deg, #194bfd 0%, #ad13fb 100%);
  transition: all 0.3s ease;
  color: #dee2e6;
  border: none;
  padding: 0.5rem 1rem;
  margin-top: 1.5rem;
  cursor: pointer;

  &:hover {
    background-color: #5a189a;
    color: #ffffff;
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(90, 24, 154, 0.5);
  }
`;

// Main Component
const Modal = ({ isOpen, onClose }) => {
  return (
    <ModalBackground $isOpen={isOpen}>
      <ModalContainer>
        <ModalHeader>Welcome to Passport Assistance Services</ModalHeader>
        <ModalContent>
          Hello, thank you for visiting our Passport Assistance Services
          website. Please note that we are not a government entity. We provide
          assistance in applying for passports, including fresh passport
          applications, re-issues, and document inquiries. As a trusted passport
          agent, we make the process seamless for you.
          <br />
          <br />
          <strong>
            For any assistance, please get in touch with us via our contact form
            or call us directly.
          </strong>
        </ModalContent>
        <CloseButton onClick={onClose}>Close</CloseButton>
      </ModalContainer>
    </ModalBackground>
  );
};

export default Modal;
